import React from "react";
import "./login.css";
import loginimg from "../assets/SIGNIN/signin.avif";
import googleLOgo from "../assets/SIGNIN/google.png";
import { signIn } from "../auth/authService";
import { useDispatch } from "react-redux";

const Login = () => {
  const dispath = useDispatch();

  return (
    <div className="logindiv">
      <img src={loginimg} alt="loginimg-bhookr" loading="lazy" />
      <div className="signinclipath">
        <p>Sign in and start your journey to a healthier, happier you!</p>
        <div
          className="loginbtn"
          onClick={() => {
            dispath(signIn());
          }}
        >
          <button>Login With Google</button>
          <img src={googleLOgo} alt="googleLOgo" loading="lazy" />
        </div>
      </div>
    </div>
  );
};

export default Login;
